import { render, staticRenderFns } from "./OTreeBreadcrumbs.vue?vue&type=template&id=6bd13d06&scoped=true&"
import script from "./OTreeBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./OTreeBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./OTreeBreadcrumbs.vue?vue&type=style&index=0&id=6bd13d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd13d06",
  null
  
)

export default component.exports